import React, { useRef } from "react";

function TextFieldEmail({
  placeholder = "Message",
  noborder = false,
  value,
  onChange,
  rows = 5,
  className = "",
  border_forced = false,
}) {
  const textAreaRef = useRef(null);

  return (
    <textarea
      ref={textAreaRef}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`h-fit  border-0 w-full  text-sm bg-white text-black rounded-xl
                  focus:outline-none 
                  placeholder-gray-400 transition duration-300 ease-in-out 
                  resize-none ${className} ${noborder ? "" : border_forced ? "p-2 border-2 border-gray-300 focus:ring-2 focus:ring-blue-500  " : "p-2 focus:ring-2 focus:ring-blue-500  "}`}
      rows={rows} // Initial row
    />
  );
}

export default TextFieldEmail;
